import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const MembershipCancel = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center" data-testid="membership-cancel-page">
        <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-slate-400" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Checkout Cancelled</h1>
        <p className="text-slate-600 mb-6">
          No worries — you can subscribe anytime. Your data is safe.
        </p>
        <div className="flex flex-col gap-3">
          <Button asChild className="bg-primary text-white hover:bg-primary/90 rounded-full">
            <Link to="/#pricing">
              <ArrowLeft className="w-4 h-4 mr-2" />
              View Plans Again
            </Link>
          </Button>
          <Button asChild variant="ghost">
            <Link to="/">Return Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MembershipCancel;
